import React from "react";
import { Link } from "react-router-dom";
import './Home.css'


const Home = ()=>{
    return (
    <div className="start-page">
        <div>
            <h3>Welcome to the VIU</h3>
            <Link to="vehicle-select">
                <div className="start-btn">
                    <span>START</span>
                </div>
            </Link>
        </div>
    </div>
    )
    
}
export default Home;